import React from "react";

const KebijakanPrivasiID: React.FC = () => (
  <>
    <p>
      PT IQ Edukasi dan (para) afiliasinya (“<strong>CoLearn</strong>”, atau “
      <strong>kami</strong>”) menyadari pentingnya perlindungan atas privasi
      dari setiap pihak yang mengakses dan/atau menggunakan (“
      <strong>Pengguna</strong>”) setiap aplikasi seluler ‘CoLearn’, situs web (
      <strong>www.colearn.id</strong>), fitur, teknologi, konten dan produk
      digital yang kami sediakan yang disebut aplikasi seluler dan situs web
      (yaitu www.colearn.id), dalam hal tertentu disebut (“
      <strong>Platform</strong>”). Kami berkomitmen untuk melindungi dan
      menghormati privasi dari Pengguna.
    </p>
    <p>
      Melalui Kebijakan Privasi ini (“<strong>Kebijakan</strong>”), kami akan
      menjelaskan kepada Pengguna bagaimana kami menggunakan data pribadi yang
      kami peroleh melalui penyediaan jasa kami kepada Pengguna dan/atau
      Pengguna berikan kepada kami (“<strong>Data Pribadi</strong>”) pada saat
      mengakses dan/atau menggunakan Platform. Kebijakan ini berlaku bagi
      seluruh Pengguna Platform, kecuali diatur secara terpisah. Kami
      menganjurkan Pengguna untuk membaca Kebijakan ini sebelum mengakses
      dan/atau menggunakan Platform.
    </p>
    <p>
      Dengan mengakses dan/atau menggunakan Platform, Pengguna dan/atau orang
      tua atau wali Pengguna (dalam hal Pengguna berusia di bawah 18 (delapan
      belas) tahun) menyatakan, menjamin dan mengakui bahwa Pengguna dan/atau
      orang tua atau wali Pengguna, telah membaca secara seksama dan memahami
      seluruh isi dan konsekuensi dari Kebijakan ini.
      <strong>
        JIKA PENGGUNA TIDAK MENYETUJUI SYARAT DAN KETENTUAN MANAPUN DALAM
        KEBIJAKAN INI, MOHON UNTUK TIDAK MELANJUTKAN UNTUK MENGAKSES DAN/ATAU
        MENGGUNAKAN PLATFORM.
      </strong>
    </p>
    <p>Kebijakan ini menjelaskan hal-hal sebagai berikut:</p>
    <ol type="A">
      <li>
        <strong>Pengumpulan Data Pribadi</strong>
        <br />
        Kami dapat mengumpulkan Data Pribadi Pengguna dengan cara sebagai
        berikut:
        <div>
          <ol type="1">
            <li>
              <strong>Data Pribadi yang Pengguna berikan kepada kami</strong>
              <br />
              Pengguna dapat memberikan Data Pribadi melalui formulir elektronik
              pada Platform kami maupun dengan berkorespondensi melalui telepon,
              surat elektronik, dan sebagainya. Data Pribadi ini meliputi
              informasi yang Pengguna berikan ketika mendaftar pada Platform
              kami, berlangganan jasa kami, mencari suatu produk, berpartisipasi
              dalam diskusi online atau fungsi media sosial lain pada Platform
              kami, mengikuti kompetisi, promosi, atau survei, serta ketika
              Pengguna melaporkan masalah dengan Platform kami atau media kami
              lainnya. Data Pribadi yang Pengguna berikan (termasuk oleh anak
              Anda pada saat mengakses atau menggunakan jasa kami) dapat
              meliputi nama, tanggal lahir, jenis kelamin, alamat, alamat surat
              elektronik, nomor telepon, tingkat/kelas dari siswa, nama sekolah,
              informasi pembayaran secara terbatas (rincian kartu kredit/debit)
              apabila diperlukan, survey atas tanggapan balik, deskripsi
              pribadi, foto, video dan data lain yang dibutuhkan untuk
              menyediakan atau memberperbaiki jasa atau untuk tujuan lain yang
              telah diindikasikan di dalam Kebijakan ini. Kami dapat meminta
              Pengguna untuk melakukan verifikasi terhadap informasi yang
              diberikan kepada kami untuk memastikan akurasi dari informasi
              tersebut.
            </li>
            <li>
              <strong>Data Pribadi yang kami kumpulkan</strong>
              <br />
              Setiap kali Pengguna mengakses dan/atau menggunakan Platform kami,
              kami dapat mengumpulkan data dan informasi berikut ini secara
              otomatis:
              <ol type="i">
                <li>
                  Informasi teknis, meliputi alamat Protokol Internet (
                  <em>IP address</em>) yang digunakan untuk menghubungkan
                  komputer Pengguna dengan internet, informasi <em>log in </em>
                  Pengguna, jenis dan versi peramban (<em>browser</em>) yang
                  digunakan, pengaturan zona waktu, jenis dan versi ekstensi
                  peramban (<em>browser plug-in</em>), metadata perangkat,
                  informasi perangkat, dan sistem operasi;
                </li>
                <li>
                  Informasi tentang kunjungan Pengguna, yang termasuk, daftar
                  lengkap Lokator Sumber Seragam (
                  <em>Uniform Resource Locators</em> atau URL) yang menuju,
                  dikunjungi melalui, dan dari Platform kami (termasuk tanggal
                  dan waktu kunjungan); produk yang Pengguna lihat atau cari;
                  waktu respon halaman, masalah pengunduhan, lama kunjungan pada
                  halaman tertentu, informasi interaksi pada halaman (seperti
                  pengguliran, klik, maupun pergerakan tetikus), metode yang
                  digunakan untuk meninggalkan Platform, serta nomor telepon
                  yang digunakan untuk menghubungi layanan pelanggan kami; dan
                </li>
                <li>
                  Data nilai Pengguna, termasuk namun tidak terbatas pada
                  analisa/hasil ujian Pengguna yang diperoleh melalui Platform.
                </li>
              </ol>
            </li>
            <li>
              <strong>Data Pribadi yang kami terima dari sumber lain</strong>
              <br />
              <p>
                Kami dapat menerima Data Pribadi jika Pengguna menggunakan situs
                lain yang kami operasikan atau jasa lain yang kami sediakan.
                Kami juga bekerja sama dengan pihak ketiga (termasuk, namun
                tidak terbatas pada, mitra bisnis, sub-kontraktor dalam
                pelayanan teknis, jasa pembayaran dan pengantaran, jaringan
                periklanan, penyedia jasa analisis situs, serta penyedia
                pencarian informasi) (&ldquo;<strong>Mitra Kami</strong>&rdquo;)
                dan dapat membagikan atau menerima informasi dari mereka. Kami
                mengambil langkah-langkah yang wajar secara komersial untuk
                melakukan verifikasi terhadap informasi yang kami dapatkan dari
                sumber lain sesuai dengan peraturan perundang-undangan yang
                berlaku.
              </p>
            </li>
          </ol>
        </div>
      </li>
      <li>
        <strong>Penggunaan Data Pribadi</strong>
        <br />
        Kami dapat menggunakan Data Pribadi Pengguna untuk hal-hal berikut ini:
        <div>
          <ol type="1">
            <li>
              Data Pribadi yang Pengguna berikan kepada Kami, dapat digunakan
              untuk keperluan sebagai berikut:
              <br />
              <ol type="i">
                <li>
                  Menjalankan kewajiban kami dalam menyediakan informasi,
                  produk, dan jasa kepada Pengguna;
                </li>
                <li>
                  Menyediakan informasi terkait produk dan jasa lain yang kami
                  tawarkan; guna menyediakan kepada Pengguna atau mengizinkan
                  pihak ketiga untuk menyediakan kepada Pengguna, informasi
                  tentang produk dan jasa yang kami anggap dapat menarik minat
                  Pengguna. Kami atau Mitra Kami dapat menghubungi Pengguna
                  secara elektronik atau cara-cara lain untuk memberikan
                  informasi tentang produk dan jasa kami;
                </li>
                <li>
                  Memberitahukan Pengguna tentang perubahan pada jasa kami;
                </li>
                <li>
                  Memastikan bahwa konten dari Platform kami disajikan dengan
                  cara yang paling efektif bagi Pengguna; dan
                </li>
                <li>
                  Kami dapat membagikan data Pengguna dengan para afiliasi Kami,
                  entitas entitas tersebut mungkin berada di luar Indonesia.
                  Informasi tersebut mungkin diperlukan secara wajar untuk
                  dibagikan dengan pihak ketiga dalam hal restrukturisasi
                  perusahaan kami atau aset bisnis dari perusahaan kami, di mana
                  aset bisnis tersebut mungkin termasuk mentransfer catatan dan
                  akses ke data Anda yang tersedia bersama kami.
                </li>
              </ol>
            </li>
            <li>
              Data Pribadi yang Kami kumpulkan, dapat digunakan untuk keperluan
              sebagai berikut:
              <br />
              <ol type="i">
                <li>
                  Mengelola Platform dan operasi internal kami, termasuk
                  pencarian sumber masalah (<em>troubleshooting</em>), analisis
                  data, pengujian, penelitian, serta tujuan- tujuan statistik
                  dan survei lainnya oleh kami atau Mitra Kami;
                </li>
                <li>
                  Memperbaiki Platform kami sehingga konten dipastikan dapat
                  disediakan dengan cara yang paling efektif untuk Pengguna;
                </li>
                <li>
                  Memungkinkan Pengguna berpartisipasi dalam fitur interaktif
                  dalam jasa kami, bertukar atau mengirim informasi untuk
                  menciptakan pemahaman menyeluruh terkait produk, jasa,
                  verifikasi, keluhan, dll;
                </li>
                <li>
                  Sebagai bagian dari usaha kami dalam memastikan keselamatan
                  dan keamanan Platform kami;
                </li>
                <li>Untuk mempersonalisasi pengalaman Pengguna;</li>
                <li>
                  Untuk memproses transaksi pembayaran Pengguna pada Plartform
                  dan mendukung penyelesaian aktivitas pembayaran dalam Platform
                  atau oleh pihak ketiga yang ditunjuk oleh kami atau Pengguna;
                  dan/atau
                </li>
                <li>
                  Memberi masukan dan rekomendasi kepada Pengguna dalam Platform
                  kami mengenai produk dan jasa yang dapat menarik minat
                  Pengguna.
                </li>
              </ol>
            </li>
            <li>
              Data Pribadi yang kami terima dari sumber lain, dapat digunakan
              untuk keperluan sebagai berikut:
              <br />
              Kami dapat menggabungkan informasi yang kami terima dari sumber
              lain dengan informasi yang Pengguna berikan dan informasi yang
              mungkin kami kumpulkan dari penggunaan atau akses Anda atas
              Platform. Kami dapat menggunakan informasi ini maupun informasi
              gabungan untuk tujuan yang diatur di atas.
            </li>
          </ol>
        </div>
      </li>
      <li>
        <strong>Pengungkapan Data Pribadi</strong>
        <br />
        Kami memiliki hak pangkalan data atas Data Pribadi yang dikumpulkan.
        Dalam penyediaan jasa kami dan pelaksanaan bisnis kami, kami dapat
        mengizinkan afiliasi kami atau Mitra Kami untuk mengakses Data Pribadi
        untuk tujuan yang terbatas.
        <br />
        Sebagai tambahan, kami dapat mengungkapkan Data Pribadi kepada pihak
        ketiga dalam hal:
        <ol type="1">
          <li>
            Pengguna telah memberikan persetujuan tertulis kepada kami untuk
            mengungkapkan Data Pribadi dengan cara tersebut;
          </li>
          <li>
            Kami menjual atau membeli perusahaan dan/atau aset perusahaan kami,
            kami dapat mengungkapkan data kepada calon pembeli atau penjual dari
            perusahaan atau aset perusahaan kami tersebut;
          </li>
          <li>
            Kami atau afiliasi kami atau aset-aset substansialnya diambil alih
            oleh pihak ketiga, maka Data Pribadi dari Pengguna kami akan menjadi
            salah satu aset yang dialihkan;
          </li>
          <li>
            Kami berada di bawah tanggung jawab untuk mengungkapkan atau
            membagikan data guna mematuhi kewajiban hukum yang berlaku dan
            perjanjian lain; atau untuk melindungi hak, harta benda, maupun
            keamanan dari kami, Pengguna, dan lain-lain. Hal ini mencakup
            pertukaran informasi dengan perusahaan dan organisasi lain untuk
            tujuan perlindungan dari penipuan dan pengurangan risiko kredit;
          </li>
          <li>
            Kami memberikan informasi statistik secara anonim tentang pengguna
            Platform dan informasi penggunaan terkait kepada pihak ketiga,
            termasuk penyelenggara situs mesin pencari dan analisis;
          </li>
          <li>
            Kami dapat juga membagikan beberapa Data Pribadi Pengguna kepada
            pihak ketiga tertentu, seperti email, alamat IP, atau informasi
            tentang peramban (<em>browser</em>), nomor identitas perangkat, atau
            sistem operasi yang Anda gunakan atau data analitik yang timbul
            darinya dengan pihak ketiga seperti pengiklan, biro iklan, dan/atau
            perantara periklanan, informasi relevan yang diperlukan untuk
            memilih dan menawarkan iklan yang relevan untuk Anda dan pengguna
            lain yang dapat menjadi iklan produk pihak ketiga dengan sifat apa
            adanya, termasuk informasi yang terkandung dalam cookie atau
            pengidentifikasi online lainnya (jika berisi Data Pribadi). Kami
            tidak membagikan Data Pribadi Pengguna yang dapat diidentifikasi
            Jika ada iklan pihak ketiga mana pun, kami tidak meminta penggunaan,
            menyetujui kualitas, atau merekomendasikan penggunaan produk atau
            layanan pihak ketiga mana pun yang diiklankan; atau
          </li>
          <li>
            Kami menggunakan penyedia jasa pihak ketiga untuk memberikan jasa
            yang melibatkan pemrosesan data, misalnya jasa arsip, audit,
            pengecekan referensi, penasihat profesional (termasuk konsultan
            hukum, akuntansi, keuangan dan bisnis), penyelenggara pengiriman
            pesan (mailing house), pengiriman, teknologi, situs web, riset,
            perbankan, pembayaran, kontak klien, pemrosesan data, asuransi,
            forensik, bantuan litigasi, pemasaran, periklanan, dan keamanan.
          </li>
        </ol>
        <p>
          Beberapa dari pihak ketiga dengan siapa kami membagikan Data Pribadi
          dapat berlokasi di luar Indonesia. Apabila pihak ketiga tersebut
          tunduk pada kewajiban privasi dan kerahasiaan, dalam hal kewajiban
          tersebut tunduk pada suatu hukum tertentu, Pengguna mengakui bahwa
          kewajiban tersebut mungkin berbeda dari dan tidak seketat peraturan
          perundang-undangan yang berlaku di Indonesia. Dalam hal tersebut kami
          tidak dapat bertanggung jawab untuk memberlakukan peraturan perundang-
          undangan Indonesia dan Pengguna tidak dapat meminta kompensasi
          berdasarkan peraturan perundang-undangan tersebut.
        </p>
      </li>
      <li>
        <strong>Penyimpanan Data Pribadi</strong>
        <br />
        Seluruh Data Pribadi yang Pengguna berikan kepada kami disimpan pada
        media penyimpanan elektronik yang aman. Dengan menyerahkan Data Pribadi
        pada Platform, Pengguna menyetujui pengalihan, penyimpanan, serta
        pengolahan yang terjadi pada Platform kami. Kami akan mengambil
        langkah-langkah dalam batas kewajaran yang diperlukan untuk memastikan
        bahwa Data Pribadi tersebut diperlakukan dengan aman dan sesuai dengan
        Kebijakan serta peraturan perundang-undangan yang berlaku.
        <p>
          Sepanjang tidak dilarang berdasarkan hukum yang berlaku, kami dapat
          menyimpan seluruh Data Pribadi Pengguna dengan ketentuan: (i)
          sepanjang Pengguna merupakan pengguna dari Platform kami; (ii) sampai
          dengan 5 (lima) tahun sejak tanggal dimana Pengguna tidak lagi
          menggunakan Platform kami (dimana pengguna menghapus Akun); atau (iii)
          sesuai dengan tujuan awal dari pengumpulan Data Pribadi, termasuk
          untuk tujuan kepatuhan terhadap hukum yang berlaku dan kebutuhan usaha
          atau tujuan dokumentasi. Lebih lanjut, kami dapat memperpanjang atau
          mengurangi jangka waktu penyimpanan Data untuk jenis-jenis data
          tertentu jika diperlukan oleh Kami: (i) dalam rangka kepentingan hukum
          atau kebutuhan usaha dan dokumentasi; dan/atau (ii) untuk menambah
          ruang penyimpanan kami, sebagaimana mungkin terjadi.
        </p>
        <p>
          Kewajiban untuk menjaga kerahasiaan Data Pribadi tidak akan atau tidak
          lagi berlaku atas Data Pribadi yang:
        </p>
        <div>
          <ol type="1">
            <li>
              telah diketahui oleh publik pada saat diungkapkan, atau yang telah
              diketahui oleh publik setelahnya dengan cara lain selain melalui
              tindakan atau kelalaian kami;
            </li>
            <li>telah diketahui oleh kami sebelum Data Pribadi diungkapkan;</li>
            <li>
              kami peroleh secara layak dari pihak ketiga tanpa adanya kewajiban
              untuk menjaga kerahasiaan Data Pribadi tersebut;
            </li>
            <li>pengungkapannya telah diizinkan oleh Pengguna; dan/atau</li>
            <li>
              harus diungkapkan berdasarkan ketentuan peraturan perundang-
              undangan yang berlaku, putusan pengadilan, atau institusi
              pemerintahan yang berwenang lainnya, di negara mana pun.
            </li>
          </ol>
          <p>
            Pengguna setuju bahwa kami tidak akan bertanggung jawab untuk setiap
            pelanggaran keamanan yang terkait pesan, informasi atau dokumen yang
            dikirimkan oleh Pengguna melalui internet.
          </p>
          <p>
            Dalam hal terjadi kegagalan dalam melindungi Data Pribadi di dalam
            Platform, maka kami akan memberitahukan kepada Pengguna secara
            tertulis baik melalui media elektronik atau lainnya, dan akan
            berusaha mengambil tindakan yang wajar secara komersial untuk
            mengamankan hal tersebut.
          </p>
        </div>
      </li>
      <li>
        <strong>Hak Pengguna</strong>
        <br />
        Pengguna dapat meminta untuk penghapusan Data Pribadi Pengguna pada
        Platform atau menarik kembali persetujuan Pengguna untuk setiap atau
        segala pengumpulan, penggunaan atau pengungkapan Data Pribadi Pengguna
        dengan memberikan kepada kami pemberitahuan yang wajar secara tertulis
        melalui detail kontak yang tercantum pada Kebijakan ini. Tergantung pada
        keadaan dan sifat permohonan yang Pengguna minta, Pengguna harus
        memahami dan mengakui bahwa setelah penarikan kembali persetujuan atau
        permohonan penghapusan tersebut, Pengguna mungkin tidak lagi dapat
        menggunakan Platform. Penarikan persetujuan Pengguna dapat mengakibatkan
        penghentian akun Pengguna atau hubungan kontraktual Pengguna dengan
        kami, dengan semua hak dan kewajiban yang muncul sepenuhnya harus
        dipenuhi. Setelah menerima pemberitahuan untuk menarik persetujuan untuk
        pengumpulan, penggunaan atau pengungkapan Data Pribadi Pengguna, kami
        akan menginformasikan Pengguna tentang konsekuensi yang mungkin terjadi
        dari penarikan tersebut sehingga Pengguna dapat memutuskan apakah
        Pengguna tetap ingin menarik persetujuan atau tidak.
        <p>
          Pengguna dapat meminta kepada kami untuk mengakses dan/atau mengoreksi
          Data Pribadi Pengguna yang berada dalam kepemilikan dan penguasaan
          kami, dengan menghubungi kami di perincian yang disediakan pada
          Kebijakan ini.
        </p>
        <p>
          Platform kami dan isinya dapat, dari waktu ke waktu, memuat tautan
          menuju dan dari situs-situs milik jaringan mitra, pihak ketiga pemuat
          iklan, dan afiliasi lainnya. Jika Pengguna mengikuti tautan menuju
          salah satu situs tersebut, mohon perhatikan bahwa situs-situs tersebut
          memiliki kebijakan privasi mereka sendiri dan bahwa kami tidak
          bertanggung jawab atau memiliki kewajiban apa pun atas kebijakan-
          kebijakan tersebut. Mohon periksa kebijakan- kebijakan tersebut
          sebelum Pengguna menyerahkan informasi apa pun ke situs-situs
          tersebut.
        </p>
      </li>
      <li>
        <strong>Kebijakan Cookies</strong>
        <br />
        Ketika Pengguna menggunakan Platform, kami dapat menempatkan sejumlah
        cookies pada peramban (<em>browser</em>) Pengguna. Cookies adalah sebuah
        berkas digital kecil berisi huruf dan angka yang kami simpan pada
        peramban (<em>browser</em>) atau diska keras (<em>hard drive</em>)
        komputer Pengguna atas persetujuan Pengguna. Cookies mengandung
        informasi yang dipindahkan ke diska keras (hard drive) komputer
        Pengguna.
        <p>
          Cookies dapat digunakan untuk tujuan berikut: (i) mengaktifkan fungsi
          tertentu; (ii) memberikan analisis; (iii) menyimpan preferensi
          Pengguna; dan (iv) memungkinkan pengiriman iklan dan pengiklanan
          berdasarkan perilaku. Beberapa cookies ini hanya akan digunakan jika
          Anda menggunakan fitur tertentu, atau memilih preferensi tertentu,
          sementara sebagian Cookies lain akan selalu digunakan.
        </p>
      </li>
      <li>
        <strong>Pengakuan dan Persetujuan</strong>
        <br />
        Dengan menyetujui Kebijakan in dengan mendaftarkan, mengakses atau
        menggunakan Platform atau layanan lain, melihat isi dari Platform,
        Pengguna dan/atau orang tua atau wali dari Pengguna (dalam hal Pengguna
        berusia di bawah 18 (delapan belas) tahun) mengakui bahwa Pengguna telah
        membaca dan memahami Kebijakan ini dan menyetujui segala ketentuannya.
        Dengan demikian, Pengguna setuju dan memberikan persetujuan kepada kami
        untuk mengumpulkan, menggunakan, membagikan, mengungkapkan, menyimpan,
        mengalihkan, atau mengolah Data Pribadi Pengguna sesuai dengan Kebijakan
        ini, dan Syarat dan Ketentuan.
      </li>
      <li>
        <strong>Kepemilikan Data</strong>
        <br />
        Dengan tunduk pada Kebijakan ini, tidak ada hak, lisensi, hak cipta atau
        hak lainnya, terlepas dari apakah hak tersebut dilindungi oleh hak
        kekayaan intelektual atau hak atas kepemilikan properti industri, yang
        secara tegas atau secara tidak langsung diberikan kepada Pengguna.
        Segala data yang berhubungan dengan Data Pribadi yang Pengguna kirimkan,
        berikan, transmisikan, unggah atau sediakan pada saat menggunakan
        Platform tetap menjadi milik Pengguna.
      </li>
      <li>
        <strong>Materi Pemasaran</strong>
        <br />
        Kami dan Mitra Kami dapat mengirimkan kepada Pengguna dan/atau orang tua
        atau wali dari Pengguna pemasaran langsung, iklan, dan komunikasi
        promosi melalui aplikasi <em>push-notification</em>, pesan melalui
        aplikasi, pos, panggilan telepon, layanan pesan singkat, email dan/atau
        aplikasi pesan lainnya (&ldquo;<strong>Materi Pemasaran</strong>&rdquo;)
        jika Pengguna telah setuju untuk berlangganan milis kami, dan/atau
        setuju untuk menerima materi pemasaran dan promosi dari kami. Pengguna
        dapat memilih untuk tidak menerima komunikasi pemasaran tersebut kapan
        saja dengan menghubungi kami melalui detail kontak yang tercantum pada
        Kebijakan ini. Mohon perhatikan bahwa jika Pengguna memilih untuk
        keluar, kami masih dapat mengirimi Pengguna pesan-pesan non- promosi,
        seperti tanda terima atau informasi tentang akun Pengguna. Dalam hal
        produk atau layanan pihak ketiga diiklankan di Platform kami dan/atau di
        konten Colearn, dengan ini kami menegaskan bahwa kami tidak
        mengkonfirmasi/memverifikasi kualitas produk/layanan pihak ketiga
        tersebut atau meminta dan mempromosikan penggunaan produk/layanan pihak
        ketiga tersebut (jika ada), dan kami tidak akan bertanggung jawab atas
        keputusan Anda untuk mengandalkan iklan tersebut dalam bentuk dan cara
        apa pun.
      </li>
      <li>
        <strong>Perubahan atas Kebijakan Privasi</strong>
        <br />
        Perubahan apa pun yang kami lakukan terhadap Kebijakan kami di masa
        depan akan diterbitkan melalui halaman ini dan, ketika dibutuhkan,
        diberitahukan kepada Pengguna melalui surat elektronik. Mohon kunjungi
        kembali halaman ini dari waktu ke waktu untuk melihat adanya
        pemutakhiran atau perubahan pada Kebijakan kami.
      </li>
      <li>
        <strong>Kontak</strong>
        <br />
        Jika Pengguna memiliki pertanyaan mengenai Kebijakan ini atau Pengguna
        ingin mendapatkan akses dan/atau melakukan koreksi terhadap Data Pribadi
        Pengguna, silahkan menghubungi kami melalui{" "}
        <a href="mailto:info@colearn.id">info@colearn.id</a>.
      </li>
      <li>
        <strong>
          Bahasa
          <br />
        </strong>
        Kebijakan ini dibuat dalam bahasa Indonesia dan bahasa Inggris. Dalam
        hal terdapat ketidaksesuaian atau perbedaan penafsiran antara versi
        bahasa Indonesia dan versi bahasa Inggris, Pengguna setuju bahwa versi
        bahasa Indonesia yang akan berlaku atas ketidaksesuaian atau
        pertentangan tersebut dan versi bahasa Inggris terkait akan dianggap
        secara otomatis diubah agar konsisten dengan bagian terkait dari versi
        bahasa Indonesia.
      </li>
    </ol>
    <p>
      Diperbarui pada: <strong>30 November 2022</strong>.
    </p>
  </>
);

export default KebijakanPrivasiID;
